// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__1eE8R","cardFace":"Card_cardFace__GITh5","cardBackFace":"Card_cardBackFace__3Kb3c","isFlipped":"Card_isFlipped__3rqWT","isInactive":"Card_isInactive__NyTe6"};